import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  header: {
    title: {
      de: 'Schnittstellen',
      en: 'Interfaces'
    },
    description: {
      de: 'Nahtlose Integration für Ihre Systeme - Verbinden Sie Ihre Anwendungen effizient.',
      en: 'Seamless integration for your systems - Connect your applications efficiently.'
    }
  }
}); 